import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CardMode } from '@components/card/card.component';
import { MdsCheckboxComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Site } from '@models/site';
import { EnvConfigurationService } from '@services/env/env-configuration.service';
import { rxjsEffect } from '@utility/utility';
import { combineLatest, filter, tap } from 'rxjs';
import { SiteServicesPatientPaceOptionsFormGroup } from './site-services-patient-pace-options.form';

@Component({
    selector: 'medpace-site-services-patient-pace-options',
    imports: [MdsCheckboxComponent, AsyncPipe],
    templateUrl: './site-services-patient-pace-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteServicesPatientPaceOptionsComponent {
    applicationNamePP = inject(EnvConfigurationService).configuration.applicationNamePP;
    mode = input.required<CardMode>();
    formGrp = input.required<SiteServicesPatientPaceOptionsFormGroup>();
    formGrp$ = toObservable(this.formGrp);
    site = input<Site>();
    site$ = toObservable(this.site).pipe(filter(Boolean));

    patch$ = rxjsEffect(() =>
        combineLatest({
            site: this.site$,
            formGroup: this.formGrp$,
        }).pipe(
            tap(({ formGroup, site }) => {
                formGroup.patchValue({
                    allowPPInvitations: site.services.allowPpinvitations,
                });
            })
        )
    );

    push(site: Site) {
        const value = this.formGrp().getRawValue();
        site.services.allowPpinvitations = value.allowPPInvitations ?? false;
        return site;
    }
}
